import { BadgeCheck } from "lucide-react";

/** "Yoxlanmış satıcı" nişanı. */
export function VerifiedBadge({
  verified,
  compact = false,
}: {
  verified?: boolean | null | undefined;
  compact?: boolean;
}) {
  if (!verified) return null;
  if (compact)
    return (
      <BadgeCheck
        className="size-4 shrink-0 text-info"
        aria-label="Yoxlanmış satıcı"
      />
    );
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-info/12 px-2.5 py-1 text-[11px] font-bold text-info">
      <BadgeCheck className="size-3.5" /> Yoxlanmış satıcı
    </span>
  );
}
